import React from 'react'
import { Link } from 'react-router-dom';
import '../styles/footer.css'

const Footer = ({ onNavigate }) => {

  const handleLinkClick = (e) => {
    e.preventDefault();
    const href = e.currentTarget.getAttribute('href');
    onNavigate(href);
  };

  return (
    <div className="footer">
      <div className="contact-button-container">
        <Link className="contact-button" onClick={handleLinkClick} to="/contact">¿HABLAMOS?</Link>
      </div>
      <div className="footer-links">
        {/* <a href="/terms-and-conditions">Terminos y condiciones</a> */}
        <Link onClick={handleLinkClick} to="/cookies-policy">Política de cookies</Link>
        {/* <a href="/privacy-policy">Política de privacidad</a> */}
      </div>
    </div>
  )
}

export default Footer